(function() {
    var GenerateRegistersModal =  function ($el) {
        this.$el = $el
        this.$selectedRegisters = null
        this.$error = this.$el.find('.modal-error')
        this.$body = this.$el.find('.modal-body')
        this.$footer = this.$el.find('.modal-footer')
        this.$formatOptions = this.$el.find('input[name=register_format]')
        this.$submitButton = this.$el.find('.confirm-generate-button')
        this.printEndpoint = this.$el.data('print-endpoint')
        this.editEndpoint = this.$el.data('edit-endpoint')
        this.classType = this.$el.data('class-type')

        this.bind()

        return this
    }

    GenerateRegistersModal.prototype.bind = function () {
        this.$submitButton.on('click', this.redirectUser.bind(this))
        this.$el.on('shown.bs.modal', this.validateModal.bind(this))
        this.$el.on('hidden.bs.modal.', this.resetModal.bind(this))
    }

    GenerateRegistersModal.prototype.getEndpointBySelectedFormat = function () {
        var selectedFormat = this.$formatOptions.filter(':checked').val()

        if (selectedFormat == 'edit') {
            return new URL(this.editEndpoint)
        }

        return new URL(this.printEndpoint)
    }

    GenerateRegistersModal.prototype.redirectUser = function (event) {
        event.preventDefault()

        var url = this.getEndpointBySelectedFormat()

        this.$selectedRegisters
            .each((e, k) => {
                url.searchParams.append(this.classType + '_ids[]', $(k).data("class-id"))            })

        window.open(url.toString())

        this.$el.modal('hide')

        this.$selectedRegisters.prop('checked', false)
    }

    GenerateRegistersModal.prototype.resetModal = function () {
        this.$body.hide()
        this.$footer.hide()
        this.$error.hide()
        this.$selectedRegisters = null
    }

    GenerateRegistersModal.prototype.showError = function () {
        this.$error.fadeIn()
    }

    GenerateRegistersModal.prototype.showBody = function () {
        this.$body.fadeIn()
        this.$footer.fadeIn()
    }

    GenerateRegistersModal.prototype.validateModal = function () {
        this.$selectedRegisters = $('.generate-register:checked')

        if (this.$selectedRegisters.length == 0) {
            this.showError()
        } else {
            this.showBody()
        }
    }

    $('.generate-registers-modal').each(function () {
        new GenerateRegistersModal($(this))
    })
})()
